import styled from "@emotion/styled";
import {css} from "@emotion/core";
import {darkBlue, iphone5Max, lightestBlue, MQ, white} from "@css/constants";
import { getTranslationY } from "@components/InfoBanner/ApptBanner.elements";
import {FontNormal} from "@css/fonts";

const TRANSITION_DELAY = 400
const BREAKPOINT_LARGE = '995px'

export const learnMoreButtonStyles = css`
  font-size: 16px; /* forcing a fixed font size: */
  max-width: 193px;
  padding: 0;
  white-space: break-spaces;
  margin-left: 5px;

  & > * {
    ${FontNormal(600)};
  }

  ${MQ.SMALL_SCREENS} {
    margin: 0 auto;
  }
`

export const LearnMoreBannerWrapper = styled('div')<{ state: string }>(props => css`
  background: ${darkBlue};
  height: ${props.state === 'exiting' ? 0 : 48}px;
  transition: height ${TRANSITION_DELAY}ms;
  position: relative;
  width: 100%;
  z-index: ${props.state === 'entering' || props.state === 'exiting' ? -1 : 0};

  ${MQ.SMALL_SCREENS} {
    height: ${props.state === 'exiting' ? 0 : 75}px;
  }
`)

export const InnerWrapper = styled('div')<{ state: string }>(props => css`
  color: ${white};
  align-items: center;
  justify-content: space-around;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  max-width: 610px;

  transform: translateY(${getTranslationY(props.state)}%);
  transition: opacity ${TRANSITION_DELAY}ms, transform ${TRANSITION_DELAY}ms;
  opacity: ${props.state === 'entering' || props.state === 'exiting' ? 0 : 1};

  @media(max-width: ${BREAKPOINT_LARGE}) {
    max-width: 700px;
  }

  ${MQ.SMALL_SCREENS} {
    box-sizing: border-box;
    padding: 5px 8px;
    height: 100%;
  }
`)

export const MessageWrapper = styled('div')(css`
  ${FontNormal(600)};
  height: 100%;
  font-size: 16px;
  margin-right: 6px;
  align-items: center;
  justify-content: space-between;
  display: grid;
  grid-template-columns: auto auto auto;
  place-content: center;

  ${MQ.SMALL_SCREENS} {
    margin: 3px 0 0 3px;
    width: 82%;
    display: block;
    height: auto;
  }
`)

export const learnMoreBannerBtnStyles = css`
  padding: 16px 0;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: underline !important;
  
  ${MQ.SMALL_SCREENS} {
    place-content: start;
    margin-left: 30px;
    padding: 0;

    & > svg {
      display: none;
    }
  }
`

export const IconWrapper = styled('div')(css`
  color: ${lightestBlue};
  margin-right: 8px;


  ${MQ.SMALL_SCREENS} {
    float: left;
    margin-top: 8px
  }
`)